// Reading AxisCare's /visits answer — the one implementation.
//
// No Supabase, no DOM, so edge functions import it through _shared/lib and
// the board, the merge seam, the billing page and the Monday run all read a
// response the same way.

/**
 * The visits in an AxisCare `/visits` response (`results.visits`), as an
 * array in which every visit carries `visitId`.
 *
 * AxisCare answers in two shapes: an object keyed by visit id, or an array
 * whose entries carry the id as `id`. Five places used to unpack this
 * themselves, and the Monday run's copy only knew the first shape — so from
 * August until 2026-10-19 every line it built had a blank axiscare_visit_id,
 * while the wizard's lines for the same visits had the real one
 * (`s=122:d=2026-10-17`). Without the id, resync falls back to matching on
 * name and date.
 */
export const visitsFromResponse = (raw) => {
  if (!raw) return [];
  return Array.isArray(raw)
    ? raw.map((v) => ({ ...v, visitId: v.visitId ?? v.id }))
    : Object.entries(raw).map(([id, v]) => ({ ...v, visitId: v.visitId ?? id }));
};

/** The client's name on a visit, "First Last", or an em dash. */
export const visitClientName = (v) =>
  v.client ? `${v.client.firstName || ''} ${v.client.lastName || ''}`.trim() : '—';

/** The caregiver's name on a visit, "First Last", or "Unassigned". */
export const visitCaregiverName = (v) =>
  v.caregiver ? `${v.caregiver.firstName || ''} ${v.caregiver.lastName || ''}`.trim() : 'Unassigned';
